import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/defend/CoreServices/CoreServices.tsx");
